import styled from "styled-components";

export const RaceDetail = styled.div`
  display: flex;
  align-self: center;
`;

export const ChangeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
